import React from "react";
import { ICellRendererParams } from "@ag-grid-community/core";

import { PickupRequestListItem } from "types";

import PickupRequestAssigneeSelect from "../../PickupRequestAssigneeSelect";

interface Props extends ICellRendererParams {
  data: PickupRequestListItem;
  canAssign: boolean;
}

const AssigneeGridCell = (props: Props) => {
  const { data, canAssign } = props;

  return (
    <PickupRequestAssigneeSelect
      requestNumber={data.requestNumber}
      status={data.statusCode}
      assigneeId={data.assignedTo ?? undefined}
      assigneeName={data.assignedToFullName ?? undefined}
      canAssign={canAssign}
    />
  );
};

export default AssigneeGridCell;
